const _ = require("lodash");
const {
	atPage,
	atUser,
	atClasses,
	atClass,
	atStudent,
	atStudents,
	atSchool,
} = require("../../core/vault/StateCursors");
const OpsSchool = require("./OpsSchool");
const URLMake = require("../../../shared/URLMake");

const validateSchoolPage = function(newState) {
	const newPage = atPage(newState).get();
	const {tab, space} = newPage;
	if (newPage.name !== "school.main") {
		return newState;
	}
	const user = atUser(newState).get();
	if (!_.get(user, "model")) {
		// Hasn't loaded yet
		return newState;
	} else {
		const userModel = user.model;
		const {staffRoles, staffSchools} = userModel;
		if (!staffRoles) {
			// Not part of a purchase
			return atPage(newState).set(URLMake.state.forOffice());
		}
		const pageData = atPage(newState).getIn("pageData");
		// Check that user has permission for the page
		const {schoolID, classID, userID, studentID} = pageData;
		const schoolState = atSchool(newState).get();
		let classIDs, schoolIDs, studentIDs, staffIDs;
		const isAccountsLoaded =
			_.get(schoolState, ["accounts", "mainLoad", "load"]) === "done";
		const isRelationsLoaded = _.get(schoolState, "entities.load") === "done";
		const isReportStudentsLoaded =
			_.get(schoolState, "report.students.load") === "done";
		const isReportClassesLoaded =
			_.get(schoolState, "report.classes.load") === "done";
		const isSingleSchool =
			isAccountsLoaded &&
			_.get(schoolState, "accounts.purchase.isSingleSchool");

		if (newPage.name === "school.main" && newPage.space === "support")
			return newState;

		if (isRelationsLoaded) {
			const relations = _.get(schoolState, "entities.relations");
			classIDs = _.filter(relations, r => r.type === "class").map(en => en.id);
			schoolIDs = _.filter(relations, r => r.type === "school").map(
				en => en.id
			);
			studentIDs = _.filter(relations, r => r.type === "student").map(
				en => en.id
			);
			staffIDs = _.filter(relations, r => r.type === "staff").map(en => en.id);
		} else {
			return newState;
		}
		if (userID || studentID) {
			if (
				(studentID && !_.includes(studentIDs, studentID)) ||
				(userID && !_.includes(_.concat(studentIDs, staffIDs), userID))
			) {
				return getDefaultSchoolPage(newState, userModel);
			} else if (space === "reports" && isReportStudentsLoaded) {
				const students = _.get(schoolState, "report.students.overall");
				if (!_.find(students, s => s.userID === studentID)) {
					return getDefaultSchoolPage(newState, userModel);
				}
			}
			return newState;
		} else if (classID) {
			if (!_.includes(classIDs, classID)) {
				return getDefaultSchoolPage(newState, userModel);
			} else if (space === "reports" && isReportClassesLoaded) {
				const classes = _.get(schoolState, "report.classes.overall", {});
				const loadedClassIDs = _.map(_.keys(classes), k => parseInt(k));
				if (!_.includes(loadedClassIDs, classID)) {
					return getDefaultSchoolPage(newState, userModel);
				}
			}
			return newState;
		} else if (schoolID) {
			if (!_.includes(schoolIDs, schoolID)) {
				return getDefaultSchoolPage(newState, userModel);
			}
			return newState;
		} else {
			if (staffRoles.adminPurchase || staffRoles.adminSchoolIDs.length) {
				// Can access the system page
				if (tab === "subscription" && !staffRoles.adminPurchase) {
					return atPage(newState).setIn("tab", "schools");
				}
				if (isSingleSchool && tab === "schools") {
					return atPage(newState).setIn("tab", "classes");
				}
				return newState;
			} else if (staffRoles.teachClassIDs.length > 1) {
				if (space === "accounts" && isAccountsLoaded) {
					const schoolsForTeacher = OpsSchool.getSchoolsForTeacher(
						schoolState,
						user.userID
					);
					if (schoolsForTeacher.length) {
						if (tab === "subscription") {
							return atPage(newState).setIn("tab", "schools");
						} else {
							return newState;
						}
					} else {
						return getDefaultSchoolPage(newState, userModel);
					}
				} else if (space === "reports") {
					if (
						(_.size(staffSchools) < 2 || isSingleSchool) &&
						tab === "schools"
					) {
						return getDefaultSchoolPage(newState, userModel);
					}
				}
				return newState;
			} else {
				// Make sure that teachers who shouldn't be able to see the subs page
				// aren't directed there when they first log in
				if (!staffRoles.adminPurchase && tab === "subscription") {
					newState = atPage(newState).setIn("tab", "schools");
				}
				return getDefaultSchoolPage(newState, userModel);
			}
		}
	}
};

const getDefaultSchoolPage = function(newState, userModel) {
	const {staffRoles, staffSchools, staffClasses, userID} = userModel;
	const newPage = atPage(newState).get();
	const {space, tab} = newPage;
	const schoolState = atSchool(newState).get();
	const isAccountsLoaded =
		_.get(schoolState, ["accounts", "mainLoad", "load"]) === "done";
	const isSingleSchool =
		isAccountsLoaded && _.get(schoolState, "accounts.purchase.isSingleSchool");
	const schoolIDs = _.map(_.keys(staffSchools), parseInt);
	if (staffRoles.adminPurchase || _.size(staffSchools) > 1) {
		return atPage(newState).set({
			name: "school.main",
			space: space || "accounts",
			tab: isSingleSchool ? "classes" : "schools",
			pageData: {},
		});
	} else if (_.size(staffSchools) === 1) {
		newState = atPage(newState).setIn("pageData", {
			schoolID: parseInt(_.keys(staffSchools)[0]),
		});
		if (tab !== "classes" && tab !== "students") {
			return atPage(newState).setIn("tab", "classes");
		} else {
			return newState;
		}
	} else if (_.size(staffClasses) > 0) {
		if (_.size(staffSchools) > 1) {
			return atPage(newState).set({
				name: "school.main",
				space: space || "accounts",
				tab: isSingleSchool ? "classes" : "schools",
				pageData: {},
			});
		} else {
			if (_.size(staffClasses) > 1) {
				const defaultSchoolID = schoolIDs[0];
				if (defaultSchoolID) {
					newState = atPage(newState).setIn(
						["pageData", "schoolID"],
						defaultSchoolID
					);
				}
				if (tab !== "classes" && tab !== "students") {
					return atPage(newState).setIn("tab", "classes");
				} else {
					return newState;
				}
			} else {
				const classIDs = _.map(_.keys(staffClasses), parseInt);
				newState = atPage(newState).setIn(["pageData", "classID"], classIDs[0]);
				return atPage(newState).setIn("tab", "classes");
			}
		}
	} else {
		// Does not have any active relations
		if (
			(isSingleSchool ||
				(_.isEmpty(staffClasses) &&
					!OpsSchool.isTeacherWithoutClasses(schoolState, userID))) &&
			tab === "schools"
		) {
			newState = atPage(newState).setIn("tab", "classes");
		}

		return newState;
	}
};

const checkReportDefault = function(oldState, newState) {
	const oldClassID = atPage(oldState).getIn("pageData.classID");
	const newClassID = atPage(newState).getIn("pageData.classID");
	const oldStudentID = atPage(oldState).getIn("pageData.studentID");
	const newStudentID = atPage(newState).getIn("pageData.studentID");
	const oldClasses = atClasses(oldState).get();
	const newClasses = atClasses(newState).get();
	const oldClassesLoad = _.get(oldClasses, [oldClassID, "status"]);
	const newClassesLoad = _.get(newClasses, [newClassID, "status"]);
	const oldStudentsLoad = _.get(atStudents(oldState).get(), [
		oldStudentID,
		"status",
	]);
	const newStudentsLoad = _.get(atStudents(newState).get(), [
		newStudentID,
		"status",
	]);

	// If we initially load a class
	// or if we switch to a class from another class
	if (
		((newClassID && newClassID !== oldClassID) ||
			(newClassesLoad === "done" && newClassesLoad !== oldClassesLoad)) &&
		!atPage(newState).getIn("pageData.grade") &&
		!atPage(newState).getIn("forPrint")
	) {
		const classInfo = atClass(newState, newClassID).get();
		newState = atPage(newState).setIn(
			["pageData", "grade"],
			_.get(classInfo, "gradeID")
		);
	}

	// Kick to school page if only one school
	// Kick to class page if only one class
	if (newClasses && !(newClassID || newStudentID)) {
		const {staffSchools, staffRoles} = atUser(newState).getIn("model");
		const isSchoolAdmin = staffRoles.adminSchoolIDs.length;
		const isPurchaseAdmin = staffRoles.adminPurchase;
		const isSingleSchool = staffRoles.isSingleSchool;
		if (
			_.size(staffSchools) === 1 &&
			!isSchoolAdmin &&
			!isPurchaseAdmin &&
			!isSingleSchool
		) {
			newState = atPage(newState).extendIn("pageData", {
				schoolID: _.keys(staffSchools)[0],
				tab: "classes",
			});
		}
		if (_.size(newClasses) === 1 && !isSchoolAdmin && !isPurchaseAdmin) {
			const oneClass = _.values(newClasses)[0];
			newState = atPage(newState).extendIn("pageData", {
				tab: "classes",
				schoolID: null,
				classID: oneClass.classID,
				grade: oneClass.gradeID,
				type: "progress",
			});
		}
	}

	// If we go to a student page without a grade filter, pop to student's grade
	if (
		((newStudentID && newStudentID !== oldStudentID) ||
			(newStudentsLoad === "done" && newStudentsLoad !== oldStudentsLoad)) &&
		!atPage(newState).getIn("pageData.grade")
	) {
		// TODO: Store last view in teacherData and default to that first
		// before defaulting to grade
		const studentInfo = atStudent(newState, newStudentID).get();
		newState = atPage(newState).setIn(
			["pageData", "grade"],
			_.get(studentInfo, "gradeID")
		);
	}

	// Keep the pageData around so switching progress/activity tabs don't
	// lose lesson/date info
	if (newStudentID || (newClassID && newClassID !== oldClassID)) {
		const keepProps = [
			"grade",
			"chapter",
			"block",
			"date",
			"typeID",
			"labBlockID",
		];
		const oldPageData = atPage(oldState).getIn("pageData");
		const newPageData = atPage(newState).getIn("pageData");
		const mergedPageData = _.extend(
			_.pick(oldPageData, keepProps),
			newPageData
		);
		newState = atPage(newState).extendIn("pageData", mergedPageData);
	}

	return newState;
};

module.exports = {
	validateSchoolPage,
	checkReportDefault,
};
